import styled from '@emotion/styled';
import { Variables } from '../variables';

interface IToggleProps {
    disabled: boolean;
    value: boolean;
}

export const Toggle = styled.div<IToggleProps>`
    --toggle-bgcolor-disabled: ${Variables.Colors.n5};
    --toggle-bgcolor-on: ${Variables.Swatches.Blue5};
    --toggle-bgcolor-off: ${Variables.Colors.n30};
    --toggle-offset: ${(props: IToggleProps): string => (props.value ? '18px' : '2px')};
    --toggle-bgcolor: ${(props: IToggleProps): string =>
        props.disabled
            ? 'var(--toggle-bgcolor-disabled)'
            : props.value
            ? 'var(--toggle-bgcolor-on)'
            : 'var(--toggle-bgcolor-off)'};

    display: flex;
    height: 20px;
    width: 36px;
    // The knob is positioned by margin, so a shrunk track collapses to a circle when off and stays
    // roughly the right size when on — the width has to hold inside a flex row.
    flex-shrink: 0;
    border-radius: 20px;

    align-items: center;
    background-color: var(--toggle-bgcolor);
    cursor: pointer;
`;

export const Knob = styled.div`
    height: 16px;
    width: 16px;
    border-radius: 16px;
    margin-left: var(--toggle-offset);
    box-shadow: 0 0 0 1px var(--toggle-bgcolor);
    background-color: ${Variables.Colors.white};

    transition: all 0.2s ease-in-out;
`;
